import http from './http';
import user from './user';
import sms from './sms';
import ems from './ems';
import config from './config';
import exam from './exam';
import question from './question';
import subject from './subject';
import questionBank from './questionBank';
import paper from './paper';
import section from './section';
import organizer from './organizer';
import dashboard from './dashboard';

export default {
  http,
  user,
  sms,
  ems,
  config,
  exam,
  question,
  subject,
  questionBank,
  paper,
  section,
  organizer,
  dashboard
};